import React from "react";
import { compose } from "recompose";
import EnhanceMiniCartContent from "./EnhanceMiniCartContent";
import CartQuery from "theme/pages/Cart/CartQuery.gql";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import MiniCartContentLoading from "./MiniCartContentLoading";
import MiniCartTitle from "./MiniCartTitle";
import Stack from "theme/components/atoms/Layout/Stack";
import MiniCartItemList from "./MiniCartItemList";
import MiniCartTotal from "./MiniCartTotal";
import MiniCartActions from "./MiniCartActions";
import MiniCartContentError from "./MiniCartContentError";

const MiniCartContent = ({ loading, error, cart }) => {
  if (loading) {
    return <MiniCartContentLoading />;
  }

  if (error) {
    return <MiniCartContentError />;
  }

  return (
    <div className="mini-cart-content">
      <div className="container">
        <div className="mini-cart-content__inner">
          <div className="mini-cart-content__main">
            <Stack size="4">
              <MiniCartTitle cart={cart} />
              <MiniCartItemList cart={cart} />
            </Stack>
          </div>
          <div className="mini-cart-content__total">
            {cart.items.length > 0 && <MiniCartTotal key="total" cart={cart} />}
          </div>
        </div>
        {cart.items.length > 0 && <MiniCartActions key="actions" cart={cart} />}
      </div>
    </div>
  );
};

export default compose(
  withHideOnErrorBoundary,
  EnhanceMiniCartContent({ CartQuery })
)(MiniCartContent);
